import { render, staticRenderFns } from "./GPathConfigList.vue?vue&type=template&id=0fb86e1c"
import script from "./GPathConfigList.vue?vue&type=script&lang=js"
export * from "./GPathConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports